import apiClient from "./client";

/** Code Companion — onboarding e acesso (CC.2): times + vínculo dev/time + grant. */

export interface CcTeamMember {
  user_id: string;
  name: string | null;
  email: string | null;
}

export interface CcTeam {
  id: number;
  name: string;
  members: CcTeamMember[];
}

export interface CcIssuedGrant {
  user_id: string;
  token: string;
}

const base = (projectId: string) => `/api/projects/${projectId}/code-companion`;

// ── Developer skill (CC.4) ───────────────────────────────────────────────────
/** Baixa o zip da skill do Code Companion (arraywise, para salvar como arquivo). */
export async function downloadSkillBundle(): Promise<Blob> {
  const res = await apiClient.get("/api/code-companion/skill-bundle", {
    responseType: "blob",
  });
  return res.data;
}

/** Self-service: o dev logado (já vinculado) gera/rotaciona o próprio grant. */
export async function issueMyGrant(projectId: string): Promise<CcIssuedGrant> {
  const res = await apiClient.post(`${base(projectId)}/my-grant`);
  return res.data;
}

// ── Teams (tenant-level) ─────────────────────────────────────────────────────
export async function listTeams(): Promise<{ total: number; items: CcTeam[] }> {
  const res = await apiClient.get("/api/code-companion/teams");
  return res.data;
}

export async function createTeam(name: string): Promise<CcTeam> {
  const res = await apiClient.post("/api/code-companion/teams", { name });
  return res.data;
}

/** Times a que o usuário logado pertence (visão do dev, sem admin). */
export async function listMyTeams(): Promise<{ total: number; items: CcTeam[] }> {
  const res = await apiClient.get("/api/code-companion/my-teams");
  return res.data;
}

export async function addTeamMember(teamId: number, userId: string): Promise<void> {
  await apiClient.post(`/api/code-companion/teams/${teamId}/members`, {
    user_id: userId,
  });
}

export async function removeTeamMember(teamId: number, userId: string): Promise<void> {
  await apiClient.delete(`/api/code-companion/teams/${teamId}/members/${userId}`);
}

// ── Project developers + grant ───────────────────────────────────────────────
export async function linkDevelopers(
  projectId: string,
  body: { user_id?: string; team_id?: number },
): Promise<{ granted: CcIssuedGrant[] }> {
  const res = await apiClient.post(`${base(projectId)}/developers`, body);
  return res.data;
}

export async function revokeDeveloper(projectId: string, userId: string): Promise<void> {
  await apiClient.delete(`${base(projectId)}/developers/${userId}`);
}
